import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/arcado_admin"; // Default za lokalno

const getData = (endpoint, headers, setData, errorMsg) => {
    axios.get(`${API_URL}${endpoint}`, { headers })
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error(`${errorMsg}:`, error);
        });
};

export default getData;